// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hrsata-jobs .organization-avatar span[data-v-219cc0a4]{display:inline-block;width:100%}", ""]);
// Exports
module.exports = exports;
